<template>
  <div class="mb-5 bg-summary p-2 px-lg-4 py-lg-3 rounded">
    <div class="row">
      <div class="col-4 py-2">
        Dates range
      </div>
      <div class="col-8 py-2 text-right">
        {{formattedDatesRange}}
      </div>
      <div class="col-4 py-2">
        Accounts
      </div>
      <div class="col-8 py-2 text-right">
        <span
          v-for="(account, index) in selectedAccountsData"
          :key="`account-${account.resourceId}`"
        >{{account.name}}<span v-if="index + 1 < selectedAccountsData.length">, </span></span>
      </div>
      <div class="col-6 py-2">
        Selected format
      </div>
      <div class="col-6 py-2 text-right">
        {{selectedFileFormat}}
      </div>
      <div class="col-12 py-2">
        <PaymentCoupon class="w-100" />
      </div>
      <div class="col-6 py-2 lead">
        Total price
      </div>
      <div class="col-6 py-2 text-right lead">
        <b>{{currencySymbols[currency]}} {{price}}</b>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { currencySymbols } from '../../constants'
import PaymentCoupon from './PaymentCoupon'

export default {
  data() {
    return {
      currencySymbols
    }
  },
  components: {
    PaymentCoupon
  },
  computed: {
    ...mapState('personal', ['selectedDateRangeValue']),
    ...mapGetters('personal', ['selectedFileFormat', 'formattedDatesRange', 'selectedAccounts', 'selectedAccountsData']),
    ...mapGetters('payment', ['price', 'currency'])
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/variables";

.bg-summary{
  background-color: $gray-100;
  background-color: var(--element-bg-dark);
}
</style>
